import React from 'react';

export const AccessDenied = () => {
    return (
        <div className="coming-soon">
            Access denied. You don't access to any functions in this module.
        </div>
    );
};